export const minimalSupportedVersions = {
  firefox: 66,
  edge: 17,
  chrome: 73,
  safari: 12
};

export function checkBrowserVersion(): boolean {
  const userAgent = navigator.userAgent;
  let browser,
   browserVersion,
   versionOffset;

  if ((versionOffset = userAgent.indexOf('Firefox')) > -1) {
    browser = 'firefox';
    browserVersion = +userAgent.substring(versionOffset + 8, versionOffset + 10);
  } else if ((versionOffset = userAgent.indexOf('Edge')) > -1) {
    browser = 'edge';
    browserVersion = +userAgent.substring(versionOffset + 5, versionOffset + 7);
  } else if ((versionOffset = userAgent.indexOf('Chrome')) > -1) {
    browser = 'chrome';
    const chromeVersionIndex = versionOffset + userAgent.substring(versionOffset).indexOf('.');
    browserVersion = +userAgent.substring(versionOffset + 7, chromeVersionIndex);
  } else if ((versionOffset = userAgent.indexOf('Safari')) > -1) {
    browser = 'safari';
    browserVersion = +userAgent.substring(versionOffset + 7);
  } else {
    browser = 'unknown';
  }

  if (browser !== 'unknown' && browserVersion !== undefined && !isNaN(browserVersion)) {
    return browserVersion < minimalSupportedVersions[browser];
  }

  return false;
}
